<div class="review-computation-table">
  <div class="review-computation-list-item highlighted">
    <span class="review-computation-list-item-description">{{
      'transfer_v2.review.label.source_currency' | translate
    }}</span>

    <div class="flex flex-col">
      <div
        *ngIf="hasDiscount"
        class="review-computation-list-item-amount"
        [attr.aria-label]="
          'promocode.discounted_transfer_amount.aria_label'
            | translate
              : { value: sourceAmountString(formData.sourceAmountPaid) }
        ">
        <span aria-hidden="true">{{
          'app.points_with_points_currency'
            | translate: sourceAmountParams(formData.sourceAmountPaid)
        }}</span>
      </div>

      <div
        [ngClass]="
          hasDiscount
            ? 'text-right text-[14px] text-[#747678] line-through ltr:ml-[5px] rtl:mr-[5px]'
            : 'review-computation-list-item-amount'
        "
        [attr.aria-label]="
          hasDiscount
            ? ('promocode.original_transfer_amount.aria_label'
              | translate: { value: sourceAmountString(formData.sourceAmount) })
            : ('app.points_with_points_currency'
              | translate: sourceAmountParams(formData.sourceAmount))
        ">
        <span aria-hidden="true">{{
          'app.points_with_points_currency'
            | translate: sourceAmountParams(formData.sourceAmount)
        }}</span>
      </div>

      <div
        *ngIf="hasDiscount"
        class="mt-[5px] text-right text-[14px] font-semibold text-[#008A02] ltr:ml-2 rtl:mr-2"
        tabindex="0"
        [attr.aria-label]="
          'promocode.code.aria_label' | translate: { value: promocode?.code }
        ">
        <rd-shared-icon
          class="mr-2 inline-block h-4 w-4 align-middle"
          iconSymbol="icon-promocode"
          iconTheme="primary"></rd-shared-icon>
        <span aria-hidden="true" class="align-middle">
          {{ promocode?.code }}
        </span>
      </div>
    </div>
  </div>

  <div class="review-computation-list-item final">
    <span class="review-computation-list-item-description">{{
      'transfer_v2.review.label.destination_currency' | translate
    }}</span>

    <span class="review-computation-list-item-amount">{{
      formattedDestinationAmount()
    }}</span>
  </div>
</div>
